import Card from 'react-bootstrap/Card';
import { Button } from 'react-bootstrap';
import CompetitionStatus from './CompetitionStatus';
import { useNavigate } from 'react-router-dom';

function CompetitionCard({ competition, onDeleteDraft, onCancel }) {
  const navigate = useNavigate();

  const onGoToCompetition = () => {
    const competitionId = competition?.id;

    if (competitionId) {
      navigate(`./${competitionId}/details`);
    }
  };

  return (
    <Card onClick={onGoToCompetition}>
      <Card.Body>
        <div className='d-flex gap-2 align-items-center'>
          <span className='h6 mb-0'>{competition.name}</span>
          <span onClick={(e) => e.stopPropagation()}>
            <CompetitionStatus
              status={competition.status}
              id={competition.id}
            />
          </span>
        </div>
        <Card.Subtitle className='my-2 text-muted fw-normal'>
          {competition.startDate
            ? new Date(competition.startDate).toLocaleDateString('sv-SE')
            : '-'}
        </Card.Subtitle>
        <div className='d-flex position-relative py-2'>
          <div style={{ width: '90%' }} className='d-flex flex-column gap-1'>
            <div className='d-flex justify-content-between bg-light'>
              <span>Sista anmälningsdag</span>
              <span>
                {competition.deadline
                  ? new Date(competition.deadline).toLocaleDateString('sv-SE')
                  : '-'}
              </span>
            </div>
            <div className='d-flex justify-content-between'>
              <span>Antal anmälda</span>
              <span>{competition.registeredParticipants}</span>
            </div>
          </div>
          <span
            className='material-symbols-outlined position-absolute'
            style={{ fontSize: '32px', right: '-10px', bottom: '50%' }}
          >
            chevron_right
          </span>
        </div>
        <Card.Footer
          style={{ paddingLeft: '0.5rem' }}
          onClick={(e) => e.stopPropagation()}
        >
          <Button
            onClick={(e) => {
              e.stopPropagation();
              onCancel(competition.id);
            }}
            disabled={competition.status !== 'Kommande'}
          >
            Ställ in tävling
          </Button>
        </Card.Footer>
      </Card.Body>
    </Card>
  );
}

export default CompetitionCard;
